export enum LongRunningTaskType {
  TEST_TASK = 'TEST_TASK',
  GOAL_DISTRIBUTION = 'GOAL_DISTRIBUTION',
}
